function removeOn() {
  let texto = document.querySelector('.article__date span');
  const novoTexto = texto.innerText.substring(3);
  
  texto.innerText = novoTexto;
}
document.addEventListener('DOMContentLoaded', removeOn);



function setReadingTime() {
  const wordsPerMinute = 200;
  const words = document.querySelector('.article__content').innerText.split(' ');
  const readingTime = Math.ceil(words.length / wordsPerMinute);
  let texto = document.querySelector('.article__reading-time span');
  
  texto.innerText = readingTime;
}
document.addEventListener('DOMContentLoaded', setReadingTime);



function share() {
  const currentURL = window.location.href;
  const postTitle = document.title;
  const shareTwitter = document.getElementById('shareTwitter');
  const shareFacebook = document.getElementById('shareFacebook');
  
  shareTwitter.addEventListener('click', () => {
    window.open(`https://twitter.com/intent/tweet?text=${postTitle}&url=${currentURL}`);
  });
  
  shareFacebook.addEventListener('click', () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${currentURL}`);
  });
}
document.addEventListener('DOMContentLoaded', share);